import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ProgramComponent } from './program.component';
import { ProgramHomeModule } from './program-home/program-home.module';
import {ProgramViewModule} from './program-view/program-view.module';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {GaService} from "../../services/site/ga.service";

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ProgramHomeModule,
    ProgramViewModule,
    NgbModule
  ],
  declarations: [
    ProgramComponent
  ],
  exports: [
    ProgramComponent,
  ],
  providers: [
    GaService
  ]
})
export class ProgramModule { }
